export default "/images/reservations_bottom.jpg?de4885cd3e6091ffba188e2fb44b82f8";